/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Unknown_PatternInputs */



/**
* | output |
* | --- |
* | "Unknown Pattern" |
*
* @param {Audit_Details_Unknown_PatternInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_unknown_pattern = /** @type {((inputs?: Audit_Details_Unknown_PatternInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Unknown_PatternInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbekanntes Muster")
	return /** @type {LocalizedString} */ ("Unknown Pattern")
});